/**
 * Created by hj on 2017/8/24.
 * change by Jession on 2018/04/04
 * 财务管理 -- 客户回款核销
 */
import React from 'react';
import {Button, message} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {openNotice, exportExcel} from 'Utils';
import {recoverListByPage} from '../../service/financialMgm';

class ReceivedPaymentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['客户回款核销'],
            showHideBtnIndex: 0,
            key: 0,
            filterBoxVisible: false,
            rows: [
                // {
                //   id: 1,
                //   name: 'jsy20171229001',
                //   cname: '金胜义',
                //   date: '2017-08-24',
                //   amount: 1000,
                //   remain: 10,
                //   type: '对公转账',
                //   remark: 'asddddddddddddd'
                // },
                // {
                //   id: 2,
                //   name: 'jsy20171229002',
                //   cname: '金胜义',
                //   date: '2017-12-24',
                //   amount: 20,
                //   remain: 10,
                //   type: '对公转账',
                //   remark: '123123123123'
                // }
            ],
            total: 1,
            searchObj: {
                /*q: '',
                effectStartDate: '',
                effectEndDate: '',
                status: '',*/
                cusname: '',  // 客户名称
                cusShortName: '',  // 客户缩写
                startDate: '',  // 收款时间（起）
                endDate: '',  // 收款时间（止）
                payType: '',  // 收款方式
                s: 10,
                p: 1
            },
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
            searchObj: {
                /*...this.state.searchObj,
                q: '',
                effectStartDate: '',
                effectEndDate: '',
                status: '',*/
                cusname: '',  // 客户名称
                cusShortName: '',  // 客户缩写
                startDate: '',  // 收款时间（起）
                endDate: '',  // 收款时间（止）
                payType: '',  // 收款方式
                s: 10,
                p: 1
            }
        }, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        });
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {  // 查询
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        this.setState({searchObj: {...this.state.searchObj, p: 1}}, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        })
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            console.log(value);
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from ? (value.from + ' 00:00:00') : '',
                    endDate: value.end ? (value.end + ' 23:59:59') : ''
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        })
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
        /* 编辑 */
        this.goView('card/add/' + this.state.rows[index].id);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        this.setState({
            loading: true
        })
        recoverListByPage(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /* 客户回款核销列表导出 */
    exportExcel() {
        let rows = this.state.rows;
        exportExcel({
            rows,
            path: '/trans/recover/exportRecover'
        });
        /*, _arr = []
        , _obj = {}
        ;
      if (!_rows.length) {
        message.warning('当前列表无数据，不能导出');
      }
      _rows.map(x => {
        _arr.push('ids=' + x.id);
      });
      _obj = _arr.join('&');
      window.location.href = `${config.server}/api/v1/dms/trans/recover/exportRecover?${_obj}`;*/
        // console.log(location.href);
        /*recoverListExportExcel({
          ids: _arr
        }).then(res => {
          if (result.status) {
            openNotice('success', '导出成功', '');
          } else {
            message.error(result.message);
          }
        });*/
    }

    render() {
        const {opts, key, filterBoxVisible, rows, total, searchObj, showHideBtnIndex, loading} = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusname',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusname
                },
                // {
                //   name: 'cusShortName',
                //   label: '客户缩写',
                //   text: '输入客户缩写',
                //   type: 'default',
                //   defaultValue: searchObj.cusShortName
                // },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '收款时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.from || '',
                        end: searchObj.end || ''
                    }
                },
                {
                    name: 'payType',
                    label: '收款方式',
                    text: '选择收款方式',
                    options: [
                        {value: '', text: '全部'},
                        {value: '现金', text: '现金'},
                        {value: '欠款', text: '欠款'},
                        {value: '代收', text: '代收'},
                        {value: '月结', text: '月结'},
                        {value: '银行', text: '银行'},
                        {value: '转账', text: '转账'},
                        {value: '支付宝', text: '支付宝'},
                        {value: '微信', text: '微信'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.payType || ''
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '收款编号',
                    dataIndex: 'recoverCode',
                    // dataIndex: 'name',
                    render: (text, record, index) => {
                        return <a href={`#/receivedPayment/detail/${record.id}`}>{text}</a>
                    }
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                    // dataIndex: 'cname'
                },
                {
                    title: '收款时间',
                    dataIndex: 'recoverDate'
                    // dataIndex: 'date'
                },
                {
                    title: '收款金额',
                    dataIndex: 'recoverCount'
                    // dataIndex: 'amount'
                },
                {
                    title: '剩余未核销金额',
                    dataIndex: 'unWritenoffCount'
                    // dataIndex: 'remain'
                },
                {
                    title: '收款方式',
                    dataIndex: 'recoverType'
                    // dataIndex: 'type'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    render: (text, record, index) => {
                        if (record.unWritenoffCount > 0) {
                            return (
                                // <Button onClick={this.goView.bind(this, `/receivedPayment/edit/${record.id}`)}>核销</Button>
                                <Button onClick={this.goView.bind(this, {
                                    pathname: `/receivedPayment/edit/${record.id}`,
                                    state: record
                                })}>核销</Button>
                            )
                        }
                    }
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goView.bind(this, `/receivedPayment/add/0`)}
                            style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>
                    <Button style={{marginLeft: 10}} onClick={this.exportExcel.bind(this)}
                            style={{position: 'absolute', bottom: 8, right: 0}} icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps}/>
                <p>收款金额汇总：</p>
            </div>
        </div>
    }
}
;
export default ReceivedPaymentList;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/receivedPaymentList.js